import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode } from 'react'

export interface CouponImageSubTitleProps {
  subTitle: ReactNode
}

export const CouponImageSubTitle = (props: CouponImageSubTitleProps) => {
  const { subTitle } = props
  return (
    <Box height={28} minWidth={64} p={1}>
      <Text variant="subtitle" color={colors.red600} noWrap lineHeight="20px" align="center" ellipsis>{subTitle}</Text>
    </Box>
  )
}
